import React, { ComponentProps } from 'react';
import { FieldWrapper } from '../FieldWrapper';
import { TextArea } from '../FormItems/TextArea';

type FieldWrapperProps = ComponentProps<typeof FieldWrapper>;

type Props = {
  textArea?: ComponentProps<typeof TextArea>;
  fieldWrapperProps: Omit<FieldWrapperProps, 'children'>;
};

export const TextAreaField: React.FC<Props> = ({
  textArea,
  fieldWrapperProps: { htmlFor, labelText, labelType, beforeMessage, errorMessages },
  ...rest
}) => (
  <FieldWrapper
    htmlFor={htmlFor}
    labelText={labelText}
    labelType={labelType}
    beforeMessage={beforeMessage}
    errorMessages={errorMessages}
  >
    <TextArea id={htmlFor} {...textArea} {...rest} />
  </FieldWrapper>
);
